import { CreateFinancialAdjustment } from 'features/Project/pages';
import Layout from 'layout';
import { LayoutProvider } from 'layout/context/layoutcontext';

function FinancialAdjustmentCreatePage() {
  return (
    <LayoutProvider>
      <Layout>
        <CreateFinancialAdjustment />
      </Layout>
    </LayoutProvider>
  );
}

export default FinancialAdjustmentCreatePage;
